import { useModal } from '@/contexts/modal'
import AddIcons from '@/icons/AddIcons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface ICreateProps {}
const CreateComponent: React.FC<ICreateProps> = () => {
    const { t } = useTranslation('contract')

    const { open, setModal } = useModal()

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                startIcon={<AddIcons />}
                onClick={() =>
                    setModal('ContractModals/PartnerContractModal/index', {})
                }
                disabled={open}
            >
                {t('create-partner-contract')}
            </Button>
            {/* {create && <Dialog open={true}></Dialog>} */}
        </>
    )
}

const Create = (props: ICreateProps) => {
    return <CreateComponent {...props} />
}
export default Create
